import { apiClient } from '@/shared/data/client';

export type GlobalSearchResultSource = 'navigation' | 'entity';

export type GlobalSearchResultType =
  | 'navigation'
  | 'project'
  | 'release'
  | 'feature'
  | 'executionRun'
  | 'resultsFile'
  | 'suite'
  | 'test'
  | 'pipeline'
  | 'job'
  | 'stage'
  | 'coverageRun'
  | 'coverageDirectory'
  | 'coverageFile';

export type GlobalSearchResultContext = {
  organisationId: string | null;
  projectId: string | null;
};

export type GlobalSearchResult = {
  id: string;
  source: GlobalSearchResultSource;
  type: GlobalSearchResultType;
  title: string;
  subtitle: string | null;
  href: string;
  context: GlobalSearchResultContext;
};

export type GlobalSearchQuery = {
  query: string;
  organisationId?: string | null;
  projectId?: string | null;
  limit?: number;
};

export type GlobalSearchResponse = {
  results: GlobalSearchResult[];
};

export const queryGlobalSearch = async (input: GlobalSearchQuery): Promise<GlobalSearchResponse> =>
  await apiClient.post<GlobalSearchResponse>('global-search/query', input, {
    orgId: null,
  });
